export const PackageConstants = {
  PackageName: {
    MaxLength: 128,
  },
  PackageDescription: {
    MaxLength: 128,
  },
  Password: {
    MinLength: 6,
    MaxLength: 128,
  },
};
